// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownTitle_wrapper_VADja"};